<template>
  <div class="profile-gift-container">
    <CategoryTitle :category="category" />

    <GiftList :mode="'checkout'" />
  </div>
</template>
<style lang="scss">
.profile-gift-container {
}
</style>
<script>
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import GiftList from "@/components/gift/GiftList.vue";

import category from "~/mixins/category";

export default {
  name: "ProfileGift",
  mixins: [category],
  components: { CategoryTitle, GiftList },
  data() {
    return {};
  }
};
</script>
